import { render, staticRenderFns } from "./DriverList.vue?vue&type=template&id=471f0642&scoped=true&"
import script from "./DriverList.vue?vue&type=script&lang=js&"
export * from "./DriverList.vue?vue&type=script&lang=js&"
import style0 from "./DriverList.vue?vue&type=style&index=0&id=471f0642&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f0642",
  null
  
)

export default component.exports